export const TOGGLE_SIDEBAR_VISIBILITY = "TOGGLE_SIDEBAR_VISIBILITY";
export const PIN_SIDEBAR = "PIN_SIDEBAR";
export const MOVE_SIDEBAR = "MOVE_SIDEBAR";
export const TOGGLE_VIEWER_LOADING_STATE = "TOGGLE_VIEWER_LOADING_STATE";
export const VIEWER_BAR_HEIGHT = "VIEWER_BAR_HEIGHT";
export const HIDE_UNPINNED_SIDEBARS = "HIDE_UNPINNED_SIDEBARS";
export const SET_SIDEBAR_WIDTH = "SET_SIDEBAR_WIDTH";
export const POP_IN_OUT_SIDEBAR = "POP_IN_OUT_SIDEBAR";
